const data = [
  {
    url:
      "https://cdn.sharechat.com/vff_blur_aa62039_1591449617922_compressed.mp4",
    channel: "Angry Cat",
    desc: "The Cat is going angry",
    song: "Just a random song",
    likes: 100,
    share: 20,
    messages: 30,
  },
  {
    url: "https://cdn.sharechat.com/318dc1e6_1597819066543_c_v.mp4",
    channel: "Cute Cats",
    desc: "Cute Cats having fun",
    song: "Cat songs having fun",
    likes: 200,
    share: 40,
    messages: 20,
  },
  {
    url: "https://cdn.sharechat.com/1474418_1595168560907_c_v.mp4",
    channel: "Cat Walk",
    desc: "Just a Random Cat walk",
    song: "Cat walk songs",
    likes: 80,
    share: 10,
    messages: 4,
  },
  {
    url:
      "https://cdn.sharechat.com/vff_blur_2c1961c2_1591450010318_compressed.mp4",
    channel: "Sleeping Cats",
    desc: "These Cats are going to sleep",
    song: "Sleeping songs for cats",
    likes: 50,
    share: 30,
    messages: 5,
  },
  {
    url:
      "https://cdn.sharechat.com/b24d2789-e1b4-43d6-85aa-414c734f9275-8b454de4-8f11-4ef3-a467-c25d8dfdea0c_compressed.mp4",
    channel: "Scary Cats",
    desc: "Cat is becoming Scary",
    song: "Scary Songs of cats",
    likes: 90,
    share: 30,
    messages: 10,
  },
  {
    url:
      "https://cdn.sharechat.com/f761ba4f-eeb9-4d60-a55a-30f2709709fb-b8788ddb-6cd1-476f-a051-3968adf29671_c_v.mp4",
    channel: "Cats Car",
    desc: "Cats sitting in car",
    song: "Car songs for cats",
    likes: 50,
    share: 20,
    messages: 9,
  },
  {
    url: "https://cdn.sharechat.com/3d704e7_1595618734427_c_v.mp4",
    channel: "Cat and Pigeon",
    desc: "COversation between cat and pegion",
    song: "COnversation songs for cat and pegion",
    likes: 40,
    share: 10,
    messages: 3,
  },
  {
    url:
      "https://cdnaws.sharechat.com/dee9a524-2f65-41c3-8b5d-d644d5760053-01cd168f-76f0-49b4-92a6-46a8a528728e_compressed.mp4",
    channel: "Cat TV",
    desc: "Cat watching tom and jerry",
    song: "Tom and Jerry show songs",
    likes: 150,
    share: 40,
    messages: 20,
  },
];
export default data;
